'use client';

import { useLocale } from 'next-intl';

import { useDomainConfiguration } from '@/components/DomainConfigurationProvider';

import {
    HiddenSections,
    PageLocale,
    WatchMoreVideo
} from '@cineamo/api/models/premium-movie-landing-page-configuration/PremiumMovieLandingPageConfigurationDto';

import { isSectionHidden } from '@/utils/landing-page/page-layout';

/**
 * The trailer the page actually renders, or null when there is nothing to play — no configured
 * trailer, or the section hidden. Everything that points at the trailer section (the hero button,
 * the menu entry) hides on null, so no control scrolls to a section that is not there.
 *
 * `trailer` is stored either as a single legacy video or per locale; both shapes are read.
 */
export function useTrailer(): WatchMoreVideo | null {
    const locale = useLocale() as PageLocale;
    const { domainConfiguration } = useDomainConfiguration();

    if (isSectionHidden(domainConfiguration, HiddenSections.TRAILER)) {
        return null;
    }

    const configuredTrailer = domainConfiguration.trailer;
    return (
        (configuredTrailer && !('key' in configuredTrailer) ? configuredTrailer[locale] : undefined) ??
        (configuredTrailer && 'key' in configuredTrailer ? configuredTrailer : null) ??
        null
    );
}
